import { Component, Mixins, Prop, Vue } from 'vue-property-decorator';
import { IEdTabsMenu } from '@/content/interfaces/ed-tabs-menu.interface';
import { IparamsSplitOrientation } from '../interfaces/params-split-orientation.interface';

@Component({})
export class EdSplitOrientationMixin extends Vue {

  @Prop() readonly params: IparamsSplitOrientation;
  @Prop({default: 'setTab'}) readonly setTab;
  @Prop({default: false }) readonly hideTabsMenu: boolean;
  
  public orientation: string = 'Horizontal';
  public menuSplitFirst: IEdTabsMenu[] = [];
  public menuSplitSecond: IEdTabsMenu[] = [];
  public contentsId: any = {
    problem: 'ProblemTab',
    response: 'ResponseTab',
    answer: 'AnswerTab',
    solution: 'SolutionTab',
    splitHorizontal: 'SplitHorizontal',
    splitVertical: 'SplitVertical',
  };
  
  get isPresentationStudentMode() : boolean {
    return this.$store.state.CourseStore.isPresentationStudentMode;
  }

  created() {
    this.menuSplitFirst = this.getMenu(this.params.menuSplitFirst);
    this.menuSplitSecond = this.getMenu(this.params.menuSplitSecond);
  }

  getMenu(menu: IEdTabsMenu[]) {
    let result = [];
    if(menu) {
      result = menu.map(m => {
        return {...m, id: `${m.contentId}${this.orientation}` }
      });
    }
    return result;
  }

  setActiveMenu(contentId: string, menu: IEdTabsMenu[]) {
    menu.forEach(m => {
      m.active = m.contentId == contentId;
    })
  }

  doSetTab(value) {
    this.$emit(this.setTab, value);
  }

}
